<template>
  <div class="navigation">
    <button 
      class="nav-btn prev-btn"
      @click="$emit('prev')"
      :disabled="!hasPrev"
    >
      <span class="nav-icon">←</span>
      <span class="nav-text">上一题</span>
    </button>
    
    <button 
      class="nav-btn answer-btn"
      @click="$emit('toggle-answer')"
      :disabled="showAnswer"
    >
      <span class="nav-icon">💡</span>
      <span class="nav-text">查看答案</span>
    </button>
    
    <button 
      class="nav-btn next-btn"
      @click="$emit('next')"
    >
      <span class="nav-text">下一题</span>
      <span class="nav-icon">→</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'GameNavigation',
  props: {
    hasPrev: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    showAnswer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style src="@/styles/Navigation.css"></style>
